import { AcLockObject } from '@utils/ac-lock-object';

export const TOASTER_TYPES = AcLockObject({
	DEFAULT: 'default',
	INFO: 'info',
	SUCCESS: 'success',
	WARNING: 'warning',
	ERROR: 'error',
});
